module.exports = __webpack_public_path__ + "static/media/ASB6000 - 4.12697d65.jpeg";